import { render, staticRenderFns } from "./pwdMt5.vue?vue&type=template&id=a14fff60&scoped=true&"
import script from "./pwdMt5.vue?vue&type=script&lang=js&"
export * from "./pwdMt5.vue?vue&type=script&lang=js&"
import style0 from "./pwdMt5.vue?vue&type=style&index=0&id=a14fff60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14fff60",
  null
  
)

component.options.__file = "pwdMt5.vue"
export default component.exports